module.exports = __webpack_public_path__ + "img/icons-arrow-up.cd401070.svg";